import React, { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import "./AddTestQuestionForm.css"; // Create this CSS file

interface AddTestQuestionFormProps {
    handleClose: () => void;
    onAddTestQuestion: (newQuestion: any) => void;
    initialData?: any;
}

export default function AddTestQuestionForm({ handleClose, onAddTestQuestion, initialData }: AddTestQuestionFormProps) {
    const [question, setQuestion] = useState(initialData?.question || "");
    const [isSingleChoice, setIsSingleChoice] = useState(initialData?.isSingleChoice ?? true);
    const [options, setOptions] = useState(
        initialData?.options.length
            ? initialData.options.map((opt: any) => ({ Key: opt.Key || `Option ${options.length + 1}`, optionText: opt.optionText, isCorrect: opt.isCorrect }))
            : [
                { Key: "A", optionText: "", isCorrect: false },
                { Key: "B", optionText: "", isCorrect: false },
                { Key: "C", optionText: "", isCorrect: false },
                { Key: "D", optionText: "", isCorrect: false },
            ]
    );
    const handleOptionChange = (index: number, field: string, value: any) => {
        const newOptions = [...options];
        newOptions[index] = { ...newOptions[index], [field]: value };
        setOptions(newOptions);
    };

    const handleAdd = () => {
        if (!question.trim()) {
            toast.error("Please enter a question.");
            return;
        }
        const filledOptions = options.filter((opt) => opt.optionText.trim());
        if (filledOptions.length < 2) {
            toast.error("Please provide at least two options.");
            return;
        }
        const hasCorrect = filledOptions.some((opt) => opt.isCorrect);
        if (!hasCorrect) {
            toast.error("Please mark at least one option as correct.");
            return;
        }

        const newQuestion = {
            question: question.trim(),
            isSingleChoice,
            options: filledOptions,
        };

        onAddTestQuestion(newQuestion);
        handleClose();
    };

    return (
        <>
            <Toaster toastOptions={{ style: { color: "black" } }} />
            <div className="addTestQuestion">
                <div className="fullDescTestQuestion">
                    <div className="headerofATestQuestion">
                        <h3>Add Test Question</h3>
                        <div
                            className="top-svg"
                            onClick={handleClose}
                            style={{ cursor: "pointer" }}
                        >
                            <svg
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15 0C18.9782 0 22.7936 1.58035 25.6066 4.3934C28.4196 7.20644 30 11.0218 30 15C30 18.9782 28.4196 22.7936 25.6066 25.6066C22.7936 28.4196 18.9782 30 15 30C11.0218 30 7.20644 28.4196 4.3934 25.6066C1.58035 22.7936 0 18.9782 0 15C0 11.0218 1.58035 7.20644 4.3934 4.3934C7.20644 1.58035 11.0218 0 15 0ZM15 13.1807L11.5157 9.69643C11.2745 9.45518 10.9473 9.31964 10.6061 9.31964C10.2649 9.31964 9.93768 9.45518 9.69643 9.69643C9.45518 9.93768 9.31964 10.2649 9.31964 10.6061C9.31964 10.9473 9.45518 11.2745 9.69643 11.5157L13.1807 15L9.69643 18.4843C9.57697 18.6037 9.48221 18.7456 9.41757 18.9016C9.35292 19.0577 9.31964 19.225 9.31964 19.3939C9.31964 19.5629 9.35292 19.7301 9.41757 19.8862C9.48221 20.0423 9.57697 20.1841 9.69643 20.3036C9.81588 20.423 9.9577 20.5178 10.1138 20.5824C10.2699 20.6471 10.4371 20.6804 10.6061 20.6804C10.775 20.6804 10.9423 20.6471 11.0984 20.5824C11.2544 20.5178 11.3963 20.423 11.5157 20.3036L15 16.8193L18.4843 20.3036C18.6037 20.423 18.7456 20.5178 18.9016 20.5824C19.0577 20.6471 19.225 20.6804 19.3939 20.6804C19.5629 20.6804 19.7301 20.6471 19.8862 20.5824C20.0423 20.5178 20.1841 20.423 20.3036 20.3036C20.423 20.1841 20.5178 20.0423 20.5824 19.8862C20.6471 19.7301 20.6804 19.5629 20.6804 19.3939C20.6804 19.225 20.6471 19.0577 20.5824 18.9016C20.5178 18.7456 20.423 18.6037 20.3036 18.4843L16.8193 15L20.3036 11.5157C20.423 11.3963 20.5178 11.2544 20.5824 11.0984C20.6471 10.9423 20.6804 10.775 20.6804 10.6061C20.6804 10.4371 20.6471 10.2699 20.5824 10.1138C20.5178 9.9577 20.423 9.81588 20.3036 9.69643C20.1841 9.57697 20.0423 9.48221 19.8862 9.41757C19.7301 9.35292 19.5629 9.31964 19.3939 9.31964C19.225 9.31964 19.0577 9.35292 18.9016 9.41757C18.7456 9.48221 18.6037 9.57697 18.4843 9.69643L15 13.1807Z"
                                    fill="#8E8EA1"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className="drag-drop-top-line"></div>
                    <div className="aTestQuestion-body">
                        <div className="dropdown">
                            <label className="cat-hello" htmlFor="question">
                                Question
                            </label>
                            <input
                                className="form-select setFirst"
                                name="question"
                                value={question}
                                onChange={(e) => setQuestion(e.target.value)}
                                placeholder="Enter test question"
                            />
                        </div>
                        <div className="dropdown mt-3">
                            <label className="cat-hello">Question Type</label>
                            <div className="radio-child">
                                <label className="align-label px-2">
                                    <input
                                        type="radio"
                                        name="questionType"
                                        checked={isSingleChoice}
                                        onChange={() => setIsSingleChoice(true)}
                                    />
                                    <span className="mx-2">Single Choice</span>
                                </label>
                                <label className="align-label px-4">
                                    <input
                                        type="radio"
                                        name="questionType"
                                        checked={!isSingleChoice}
                                        onChange={() => setIsSingleChoice(false)}
                                    />
                                    <span className="mx-2">Multiple Choice</span>
                                </label>
                            </div>
                        </div>
                        <div className="mt-3">
                            <label className="cat-hello">Options</label>
                            {options.map((opt, index) => (
                                <div key={opt.Key} className="option-row">
                                    <input
                                        type="text"
                                        className="form-control option-input"
                                        value={opt.optionText}
                                        onChange={(e) => handleOptionChange(index, "optionText", e.target.value)}
                                        placeholder={`Option ${opt.Key}`}
                                    />
                                    <label className="correct-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={opt.isCorrect}
                                            onChange={(e) => handleOptionChange(index, "isCorrect", e.target.checked)}
                                        />
                                        <span className="mx-2">Correct</span>
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="drag-drop-top-line"></div>
                    <div className="down-buttons d-flex">
                        <button className="create-button" onClick={handleAdd}>
                            Add Question
                        </button>
                        <button className="cancel-button" onClick={handleClose}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}